<template>
	<v-sheet class="project" style="height: calc(100vh - 88px)">
		<v-row md="12" class="d-flex" v-if="false">
			<v-col md="3">
				<StatusCard
					type="report"
					icons="mdi-account-group-outline"
					heading="Initial Stock"
					:statusCount="tableSummary?.inital_stock_count"
					statusColor="blue"
					textColor="blue--text"
				></StatusCard>
			</v-col>
			<v-col md="3">
				<StatusCard
					type="report"
					icons="mdi-account-group-outline"
					heading="Received Stock"
					subHeadingText="(In Bound)"
					:statusCount="tableSummary?.received_stock_count"
					statusColor="cyan darken-1"
					textColor="cyan--text darken-1"
				></StatusCard>
			</v-col>
			<v-col md="3">
				<StatusCard
					type="report"
					icons="mdi-account-group-outline"
					heading="Out Stock"
					subHeadingText="(Out Bound)"
					:statusCount="tableSummary?.out_stock_count"
					statusColor="deep-orange darken-2"
					textColor="deep-orange--text darken-2"
				></StatusCard>
			</v-col>
			<v-col md="3">
				<StatusCard
					type="report"
					icons="mdi-account-group-outline"
					heading="Final Stock"
					:statusCount="tableSummary?.final_balance"
					statusColor="orange darken-2"
					textColor="orange--text darken-2"
				></StatusCard>
			</v-col>
		</v-row>
		<v-col md="12" class="py-1 my-auto text-right listing-right">
			<template>
				<v-menu
					bottom
					left
					origin="center center"
					transition="slide-y-transition"
					rounded="0"
					offset-y
					max-height="400px"
					max-width="500"
					:close-on-content-click="false"
					content-class="white-background"
				>
					<template v-slot:activator="{ on, attrs }">
						<v-btn
							depressed
							color="blue darken-4"
							class="text-white"
							tile
							:disabled="pageLoading"
							v-bind="attrs"
							v-on="on"
						>
							<v-icon>mdi-table-edit</v-icon>
						</v-btn>
					</template>
					<Draggable
						tag="ul"
						v-model="draggableThead"
						class="draggable-group"
						handle=".draggable-drag-icon"
						v-on:change="updateTable('adjustment-report')"
					>
						<template v-for="cols in draggableThead">
							<li
								style="min-width: 300px !important"
								class="draggable-group-item"
								:key="cols.key"
								v-if="!cols.checkbox"
							>
								<v-checkbox
									dense
									v-model="draggableTheadShow"
									v-bind:value="cols.key"
									:label="cols.name"
									:disabled="cols.fixed || pageLoading"
									color="blue"
									hide-details
									class="mt-0 mb-0"
									v-on:change="updateTableVisiblity('adjustment-report')"
								></v-checkbox>
								<v-icon
									v-if="!pageLoading && !cols.fixed"
									class="draggable-action draggable-drag-icon"
									right
									color="blue"
									>mdi-drag</v-icon
								>
								<v-icon v-else right class="draggable-action" color="grey">mdi-drag</v-icon>
							</li>
						</template>
					</Draggable>
				</v-menu>
				<v-btn
					depressed
					:disabled="pageLoading"
					color="blue darken-4"
					class="text-white"
					tile
					v-on:click="advanceSearch = true"
				>
					<v-icon>mdi-filter</v-icon>
				</v-btn>
			</template>
		</v-col>
		<SearchCriteria
			v-if="searchEnabled()"
			:search-fields="listingFilter"
			search-string="Adjustment #, Product Name, Product Serial Number, Type"
			v-on:advance-search="advanceSearch = true"
			v-on:close-search="resetSearch"
		></SearchCriteria>
		<Table
			:page-loading="pageLoading"
			type="adjustment-report"
			detail-route="adjustment-report"
			v-on:reload:content="filterRows"
			delete-note="All transactions of this report will also be deleted."
		></Table>
		<ExportDialogNew
			endpoint="project/export"
			title="Export Project"
			:cols="draggableThead"
			:export-dialog.sync="exportDialogNew"
			v-on:close="exportDialogNew = false"
		></ExportDialogNew>
		<ImportDialog
			endpoint="project/import?type=project"
			title="Projects"
			:import-dialog="importDialog"
			v-on:close="importDialog = false"
		></ImportDialog>
		<FilterDialog
			title="adjustment stock history"
			:filter-dialog="advanceSearch"
			:btx-filter="listingFilter"
			:btx-query="btxQuery"
			v-on:do-search="doAdvanceSearch"
			v-on:close="advanceSearch = false"
		>
		</FilterDialog>
	</v-sheet>
</template>
<script>
import ListingMixin from "@/core/mixins/listing.mixin";
import StatusCard from "@/view/components/statusCard.vue";

export default {
	name: "adjustment-report",
	title: "Adjustments Listing",
	mixins: [ListingMixin],
	components: {
		StatusCard,
	},
	methods: {
		updateDialog(uuid) {
			this.uuid = uuid;
			this.dialog = true;
		},
	},
	data() {
		return {
			uuid: null,
			dialog: false,
			pageTitle: "Adjustment Report",
			pageBreadcrumbs: [{ text: "adjustment-report", disabled: true }],
			endpoint: "report/adjustment-report",
			defaultFilter: {},
		};
	},
};
</script>
